class RangeSlider extends BaseElement
{
  init ()
  {
    this.min = typeof(this.dataset.min) !== 'undefined' ? parseInt(this.dataset.min) : 0;
    this.max = typeof(this.dataset.max) !== 'undefined' ? parseInt(this.dataset.max) : 0;
    this.start = typeof(this.dataset.start) !== 'undefined' ? parseInt(this.dataset.start) : 0;
    this.end = typeof(this.dataset.end) !== 'undefined' ? parseInt(this.dataset.end) : 100;
    this.step = typeof(this.dataset.step) !== 'undefined' ? parseInt(this.dataset.step) : 1;
    this.slider = noUiSlider.create(this, this.config());

    this.slider.on('change', e => {
      this.dispatchEvent(new CustomEvent('change', {
        detail: {
          range: this.range()
        }
      }));
    });

    this.slider.on('update', e => {
      this.dispatchEvent(new CustomEvent('update', {
        detail: {
          range: this.range()
        }
      }));
    });
  }

  setMinMax (min, max)
  {
    this.min = min;
    this.max = max;
    this.start = min;
    this.end = max;
    this.slider.updateOptions(this.config());
  }

  gap ()
  {
    return (this.max - this.min) * 0.05; // 5% gap
  }

  config ()
  {
    return {
      start: [this.start, this.end],
      connect: true,
      margin: this.gap(),
      step: this.step,
      range: {
        min: this.min,
        max: this.max
      }
    }
  }

  range ()
  {
    const data = this.slider.get();

    return {
      start: parseInt(data[0]),
      end: parseInt(data[1])
    };
  }

  setStart (start)
  {
    this.slider.set([start, null]);

    return this;
  }

  setEnd (end)
  {
    this.slider.set([null, end]);

    return this;
  }
}

if (!customElements.get('range-slider')) {
  customElements.define('range-slider', RangeSlider);
}